import React from 'react';
import cx from 'classnames';
import styles from './logo.module.css';

// eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
const Logo = ({ className, ...attrs }) => <img alt="" className={cx(className, styles.logo_small)} {...attrs} />;

export default Logo;
